__webpack_require__.p = "https://app-static.laigu.com/fe-workbench-laigu/v1.2026.02.11-01.20260211_260/";